import React, { useEffect } from "react";
import { api, userService } from "../../_services";

const IntuitInit = () => {
  const currentUser = userService.getLoggedInUser();
  const init = async () => {
    let url = await api.getIntuitAuthUrl(currentUser.entityId);
    if (url) {
      window.location.href = url;
    }
  };

  return (
    <React.Fragment>
      <button type="button" className="btn btn-primary" onClick={init}>
        Init
      </button>
    </React.Fragment>
  );
};

export default IntuitInit;
